/**
 * Copyright 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch, SetStateAction } from "react";
import { createCtx } from "~/tools";
import { PlanData } from "./constants";

type Props = {
  planData?: PlanData;
  setPlanData: Dispatch<SetStateAction<PlanData>>;
  setSelectedEntity?: (id?: string) => void;
  selectedEntity?: string;
};

export const [usePlanWizard, PlanWizardCtxProvider] = createCtx<Props>();
